/* eslint-disable camelcase */
// the unused vars need to be there otherwise the component doesn't rerender on those property change
/* eslint-disable no-unused-vars */
import React from 'react';
import { observer } from 'mobx-react';
import { Card, HSpacer, Button, LoadingOverlay } from '@mqd/volt-base';
import PropTypes from 'prop-types';
import { ParentDetailCard } from '@mq/voltron-parent';
import BusinessDetailsHome from 'components/business-details/BusinessDetailsHome.js';
import BusinessDetailsBaseInfo from 'components/business-details/BusinessDetailsBaseInfo';

class BeneficialOwnerCard extends ParentDetailCard {
  constructor(props) {
    super(props);
    this.handleSave = this.handleSave.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.state = {
      editActive: false,
      showAddIdentificationModal: false,
      loading: false,
    };
  }

  get businessStore() {
    const { businessStore } = this.props;
    return businessStore || {};
  }

  get beneficialOwner() {
    const { beneficialOwner = {} } = this.props;
    return beneficialOwner || {};
  }

  get cardTitle() {
    const { cardTitle } = this.props;
    return cardTitle || 'Beneficial Owner';
  }

  async handleSave() {
    const { updateBusiness } = this.businessStore;
    this.setState({ loading: true });
    const success = await updateBusiness();
    if (success) {
      this.setState({ loading: false, editActive: false });
    } else {
      this.setState({ loading: false });
    }
  }

  handleCancel() {
    const { revertUpdates } = this.businessStore;
    revertUpdates && revertUpdates();
    this.setState({ editActive: false });
  }

  renderHome() {
    const { editActive } = this.state;
    const { home = {} } = this.beneficialOwner;

    return (
      <BusinessDetailsHome
        ownerType="beneficial owner"
        editActive={editActive}
        home={home}
        renderSnippet={this.renderSnippet}
      />
    );
  }

  renderHeaderButtons() {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Button type="outline" onClick={this.handleCancel}>
          Cancel
        </Button>
        <HSpacer />
        <Button onClick={this.handleSave}>Save</Button>
      </div>
    );
  }

  renderBaseInfo() {
    const { editActive } = this.state;

    return (
      <BusinessDetailsBaseInfo
        ownerType="beneficial owner"
        editActive={editActive}
        person={this.beneficialOwner}
        renderSnippet={this.renderSnippet}
      />
    );
  }

  render() {
    const { loading } = this.state;
    const { editable } = this.props;
    const { editActive } = this.state;
    const testId = `${this.cardTitle.replace(/\s+/g, '-').toLowerCase()}-card`;

    return (
      <LoadingOverlay active={loading}>
        <Card
          title={this.cardTitle}
          testId={testId}
          controls={editable && (editActive ? this.renderHeaderButtons() : this.renderControl())}
        >
          {this.renderBaseInfo()}
          {this.renderHome()}
        </Card>
      </LoadingOverlay>
    );
  }
}

BeneficialOwnerCard.propTypes = {
  cardTitle: PropTypes.string,
  beneficialOwner: PropTypes.object,
  businessStore: PropTypes.any,
  editable: PropTypes.bool,
};

BeneficialOwnerCard.defaultProps = {
  cardTitle: 'Beneficial Owner',
  beneficialOwner: {},
  businessStore: {},
  editable: false,
};

export default observer(BeneficialOwnerCard);
